import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { OrganizationsByRoleInterface } from '@sport-activities/sdk';
import { Subscription } from 'rxjs';
import { APP_STORAGE } from '~/app.token';

import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { OrganizationService } from '~/core/services/organization/organization.service';
import { RedirectionService } from '~/core/services/redirection/redirection.service';

const USER_ORGANIZATIONS = 'userOrganizations';
const CURRENT_ORGANIZATION = 'currentOrganization';

@Component({
  selector: 'app-organization-choice-page',
  templateUrl: './organization-choice-page.component.html',
  styleUrls: ['./organization-choice-page.component.scss'],
})
export class OrganizationChoicePageComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();
  public organizations: OrganizationsByRoleInterface[];
  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly logoType = LogoTypeEnum;
  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;

  constructor(
    @Inject(APP_STORAGE) private readonly storage: Storage,
    private readonly organizationService: OrganizationService,
    private readonly redirectionService: RedirectionService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.storage.removeItem(CURRENT_ORGANIZATION);

    const storedOrganizations = JSON.parse(
      this.storage.getItem(USER_ORGANIZATIONS)
    );

    if (storedOrganizations) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
      this.organizations = storedOrganizations.map((org) => ({
        ...org,
        organizations: [...org.organizations].sort((a, b) =>
          (a.name ?? '').localeCompare(b.name ?? '')
        ),
      }));
    } else {
      this.organizationService
        .getOrganizationsFromAuthUser()
        .subscribe((organizations) => {
          this.organizations = organizations;
        });
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  public saveOrganization(organization): void {
    const organizationToSave = JSON.stringify(organization);
    this.storage.setItem(CURRENT_ORGANIZATION, organizationToSave);
    this.redirectionService.redirect('organizer.planning.planning');
  }
}
